import { Controller } from '@hotwired/stimulus';

// Revises bootstrap carousel cards so that each card in the carousel has the height of the tallest card
export default class extends Controller {
  connect() {
    this.#setConsistentHeights();
  }

  #setConsistentHeights() {
    var carouselItems = this.element.querySelectorAll('.carousel-item');
    var maxHeight = this.#getMaxHeight(carouselItems);

    // Only set fixed height on desktop (md breakpoint and up)
    // On mobile, let the carousel height be natural to avoid large gaps
    if (window.matchMedia('(min-width: 768px)').matches) {
      this.element.style.height = maxHeight + 'px';
    } else {
      this.element.style.height = '';
    }
  }

  #getMaxHeight(carouselItems) {
    var maxHeight = 0;
    var isFirst = true;

    carouselItems.forEach(function (item) {
      // We need to render the hidden slides onscreen to get their height
      item.style.position = 'absolute';
      item.style.left = '-9999px';
      item.style.visibility = 'hidden';
      if (!isFirst) {
        item.classList.add('active');
      }

      var height = item.clientHeight;
      maxHeight = Math.max(maxHeight, height);

      // After getting the height, hide the non-active slides again
      item.style.position = '';
      item.style.left = '';
      item.style.visibility = '';
      if (!isFirst) {
        item.classList.remove('active');
      } else {
        isFirst = false;
      }
    });
    return maxHeight;
  }
}
